import { connect } from 'react-redux';
import { getBrandBarberShops } from '../../../selector';

export default connect(state => ({
  barberShops: getBrandBarberShops(state),
}));
